import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { DesignBtn } from '../Common';
import { useNavigate } from 'react-router-dom';

const Shoot = ({
    primaryImg,
    title,
    price,
    TitlefontSize,
    Pricefontsize,
    buttonwidth,
    slug,
    TrouserMeter,
    KurtaMeter,
    FabricType,
    ShirtMeter,
    PaintMeter,
    DiscountPrice,
    imageHeight = ""
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    const redirectToShop = () => {
        console.log("click");
        navigate("/cart/" + slug);
    }

    const discountPercentage = DiscountPrice && price
        ? Math.round(((DiscountPrice - price) / DiscountPrice) * 100)
        : null;

    return (
        <>
            <Box sx={{
                px: 1.5,
                border: "1px solid transparent",
                transition: ".3s ease-in-out",
                my: 2,
                cursor: 'pointer',
                '&:hover': {
                    '& .title': {
                        color: theme.palette.primary.gold
                    },
                }
            }}>
                <Box
                    onClick={redirectToShop}
                    sx={{
                        position: 'relative',
                        overflow: 'hidden',
                        width: "100%",
                        height: { md: imageHeight ? imageHeight : "320px", sm: "100%" }
                    }}
                >
                    {discountPercentage && (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 20,
                                right: -34,
                                width: '140px',
                                transform: 'rotate(45deg)',
                                backgroundColor: '#D4AF37', // Golden color
                                color: '#fff',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                fontSize: { xs: '12px', sm: '16px' },
                                py: 0.5,
                                zIndex: 2,
                                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                            }}
                        >
                            {discountPercentage}% OFF
                        </Box>
                    )}

                    <img src={primaryImg} width='100%' height='100%' style={{ objectFit: 'cover' }} />
                </Box>

                <Box sx={{ padding: '25px', textAlign: 'center', height: '140px' }}>
                    <Typography
                        className='title'
                        variant='h5'
                        sx={{
                            fontFamily: theme.palette.typography.fontFamily1,
                            color: '#fff',
                            fontSize: TitlefontSize,
                            transition: 'all 0.3s ease-in-out'
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        sx={{
                            color: '#848484',
                            fontFamily: theme.palette.typography.fontFamily1,
                            fontSize: Pricefontsize,
                            margin: '6px 0 8px'
                        }}
                    >
                        Price : ₹{price} <del>₹{DiscountPrice}</del>
                    </Typography>

                    {
                        FabricType == "Kurta" ? (
                            <>
                                <Typography
                                    variant='span'
                                    sx={{
                                        color: '#848484',
                                        fontFamily: theme.palette.typography.fontFamily1,
                                        fontSize: Pricefontsize,
                                        margin: '6px 4px 8px'
                                    }}
                                >
                                    Kurta : {KurtaMeter} Mtr
                                </Typography>

                                <Typography
                                    variant='span'
                                    sx={{
                                        color: '#848484',
                                        fontFamily: theme.palette.typography.fontFamily1,
                                        fontSize: Pricefontsize,
                                        margin: '6px 4px 8px'
                                    }}
                                >
                                    Trouser : {TrouserMeter} Mtr
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography
                                    variant='span'
                                    sx={{
                                        color: '#848484',
                                        fontFamily: theme.palette.typography.fontFamily1,
                                        fontSize: Pricefontsize,
                                        margin: '6px 4px 8px'
                                    }}
                                >
                                    Shirt : {ShirtMeter} Mtr
                                </Typography>

                                <Typography
                                    variant='span'
                                    sx={{
                                        color: '#848484',
                                        fontFamily: theme.palette.typography.fontFamily1,
                                        fontSize: Pricefontsize,
                                        margin: '6px 4px 8px'
                                    }}
                                >
                                    Paint : {PaintMeter} Mtr
                                </Typography>
                            </>
                        )
                    }

                    <Box sx={{ width: buttonwidth, mb: 2, mx: 'auto', mt: 2 }} >
                        <DesignBtn padding={'5px 10px'} text={'Add to cart'} slug={slug} />
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default Shoot;
